"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepCompareEffect = exports.useDeepCompareMemoize = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const react_fast_compare_1 = tslib_1.__importDefault(require("react-fast-compare"));
function useDeepCompareMemoize(value) {
    const ref = react_1.useRef();
    if (!react_fast_compare_1.default(ref.current, value)) {
        ref.current = value;
    }
    return ref.current;
}
exports.useDeepCompareMemoize = useDeepCompareMemoize;
function useDeepCompareEffect(callback, dependencies) {
    react_1.useEffect(callback, useDeepCompareMemoize(dependencies));
}
exports.useDeepCompareEffect = useDeepCompareEffect;
//# sourceMappingURL=useDeepCompareEffect.js.map